// extracted by mini-css-extract-plugin
module.exports = {"bigTitle":"BrandsBigTitle_bigTitle__1bKwv","finished":"BrandsBigTitle_finished__3uu9e"};